import wordpress from '../assets/icons/integration/wordpress.png';
import api from '../assets/icons/integration/api.png';

export const integration: Integration[] = [
    {
        name: 'WordPress',
        description: 'Plugin Oficial',
        icon: wordpress,
        url: '/integraciones/wordpress',
        link: true
    },
    {
        name: 'Custom API',
        description: 'Integración directa',
        icon: api,
        url: 'https://www.pagosfiable.com/docs/',
        link: false

    },

];

interface Integration {
    name: string;
    description: string;
    icon: unknown; // si usas Next.js con `next/image`]
    url?: string;
    link?: boolean;
}
